import React from "react";
import {ListItemIcon, MenuItem} from "@material-ui/core";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ListItemText from "@material-ui/core/ListItemText";


export const QuickActionMenuItem = ({
        icon,                // FontAwesome icon definition (existing)
        iconNode,            // NEW: arbitrary React node icon
        swapOpacityToggle = false,
        className,
        classes,             // kept for backward compatibility
        ListItemIconProps,
        ListItemTextProps,
        children,
        onClick,
        ...menuItemProps
}) => {
    const renderedIcon = iconNode
        ? iconNode
        : (icon ? <FontAwesomeIcon icon={icon} swapOpacity={swapOpacityToggle}/> : null);

    return (
        <MenuItem
            className={className || classes}
            onClick={onClick}
            {...menuItemProps}
        >
            {renderedIcon && (
                <ListItemIcon style={{marginRight: -20}} {...ListItemIconProps}>
                    {renderedIcon}
                </ListItemIcon>
            )}
            <ListItemText {...ListItemTextProps}>
                {children}
            </ListItemText>
        </MenuItem>
    );
};